import { Images } from "assets";
import React, { useState } from "react";
import { Image, StyleSheet, View, TouchableOpacity, ScrollView } from "react-native";
import { fp, hp, wp } from "utils/normalizeV2";
import FavdislikeCardComponent from "./favdislikeCardComponent";
import VText from "components/VText";

const SelectProductCardComponent = ({ outfitData, selectedProducts, setSelectedProducts }) => {
    const renderGridItem = (item) => (
        <TouchableOpacity
            key={item.id}
            style={styles.gridItem}
            onPress={() => {
                setSelectedProducts((prev) =>
                    prev.some((product) => product.id === item.id)
                        ? prev.filter((product) => product.id !== item.id)
                        : [...prev, item]
                );
            }}
        >
            <View style={styles.imageContainer}>
                <Image source={{ uri: item?.imageUrls[0] }} style={styles.productImage} resizeMode="cover" />
            </View>
            <Image
                source={
                    selectedProducts?.some((product) => product.id === item.id) ? Images.blackSelect : Images.greySelect
                }
                style={styles.checkIcon}
            />
        </TouchableOpacity>
    );

    const renderSelectedProducts = () => {
        return selectedProducts?.map((product) => (
            <FavdislikeCardComponent marginRight={wp(10)} key={product.id} showViewSimilar={false} item={product} />
        ));
    };

    return (
        <View style={styles.container}>
            <View style={styles.gridContainer}>{outfitData?.map(renderGridItem)}</View>
            <VText style={styles.title}>Select Products</VText>
            {selectedProducts?.length > 0 && (
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    style={styles.selectedProductsContainer}
                    contentContainerStyle={styles.selectedProductsContent}
                >
                    {renderSelectedProducts()}
                </ScrollView>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
    },
    gridContainer: {
        marginLeft: wp(5),
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        gap: wp(1),
    },
    gridItem: {
        width: "32.7%",
    },
    imageContainer: {
        width: "100%",
        aspectRatio: 1,
        height: hp(300),
        overflow: "hidden",
        position: "relative",
    },
    productImage: {
        width: "100%",
        height: "100%",
    },
    checkIcon: {
        position: "absolute",
        bottom: wp(10),
        right: wp(10),
        width: wp(20),
        height: wp(20),
    },
    selectedProductsContainer: {
        marginTop: hp(20),
    },
    selectedProductsContent: {
        paddingHorizontal: wp(5),
        flexDirection: "row",
    },
    selectedProduct: {
        width: wp(150),
        height: wp(150),
    },
    title: {
        fontWeight: "400",
        fontSize: wp(20),
        // marginBottom: hp(10),
        marginLeft: wp(10),
        marginTop: hp(15),
    },
});

export default React.memo(SelectProductCardComponent);
